import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Input,
  FormGroup,
  Label,
  Button,
  Spinner,
  Alert
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import createAmazonBook from "common/realBackend/blog/createAmazonBook";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const BookCreate = () => {
  document.title = "Create Amazon Book | AAOOA Admin";

  const [coverImagePreview, setCoverImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Book Title is required"),
    coverImage: Yup.mixed().required("Cover Image is required"),
    amazonLink: Yup.string().url("Invalid URL format").required("Amazon Book Link is required"),
    amazonLinkTwo: Yup.string().url("Invalid URL format").required("Amazon UK Book link is requred"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    const { title, coverImage, amazonLink, amazonLinkTwo } = values;

    setLoading(true);
    try {
      await createAmazonBook(title, amazonLink, amazonLinkTwo, coverImage);
      setAlertMessage("Amazon Book created successfully!");
      setAlertVisible(true);

      resetForm();
      setCoverImagePreview(null);
    } catch (error) {
      console.error("Error creating Amazon book:", error);
      setAlertMessage("Error creating book. Please try again.");
      setAlertVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Books" breadcrumbItem="Create Amazon Book" />

        {/* Alert for success or error */}
        {alertVisible && (
          <Alert
            color={alertMessage.includes("Error") ? "danger" : "success"}
            toggle={() => setAlertVisible(false)}
            style={{ position: "fixed", top: "1rem", right: "1rem", zIndex: 1050 }}
          >
            {alertMessage}
          </Alert>
        )}

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-4">Create New Amazon Book</CardTitle>
                <Formik
                  initialValues={{
                    title: "",
                    description: "",
                    coverImage: null,
                    amazonLink: "",
                    amazonLinkTwo: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ setFieldValue, resetForm }) => (
                    <Form>
                      <FormGroup className="mb-4">
                        <Label htmlFor="title" className="col-form-label">Book Title</Label>
                        <Field
                          id="title"
                          name="title"
                          as={Input}
                          placeholder="Enter Book Title..."
                        />
                        <ErrorMessage name="title" component="div" className="text-danger" />
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <Label className="col-form-label">Cover Image</Label>
                        <Input
                          type="file"
                          className="form-control"
                          onChange={(e) => {
                            const file = e.currentTarget.files[0];
                            setFieldValue("coverImage", file);
                            setCoverImagePreview(URL.createObjectURL(file));
                          }}
                        />
                        {coverImagePreview && (
                          <div className="mt-2">
                            <img src={coverImagePreview} alt="Cover Preview" style={{ maxWidth: "250px", height: "auto" }} />
                          </div>
                        )}
                        <ErrorMessage name="coverImage" component="div" className="text-danger" />
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <Label htmlFor="amazonLink" className="col-form-label">Amazon Book Link</Label>
                        <Field
                          id="amazonLink"
                          name="amazonLink"
                          as={Input}
                          placeholder="Enter Amazon Book Link..."
                        />
                        <ErrorMessage name="amazonLink" component="div" className="text-danger" />
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <Label htmlFor="amazonLinkTwo" className="col-form-label">Amazon Book Link (UK)</Label>
                        <Field
                          id="amazonLinkTwo"
                          name="amazonLinkTwo"
                          as={Input}
                          placeholder="Enter Amazon UK Book Link..."
                        />
                        <ErrorMessage name="amazonLinkTwo" component="div" className="text-danger" />
                      </FormGroup>

                      <Row className="justify-content-end">
                        <Col lg="10">
                          <Button type="submit" color="primary" disabled={loading}>
                            {loading ? <Spinner size="sm" /> : "Create Amazon Book"}
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BookCreate;
